module.exports = __webpack_public_path__ + "static/media/maintenance-showcase.c867d8a4.mov";